import { render, staticRenderFns } from "./vertify.vue?vue&type=template&id=ed9f4fce&scoped=true"
import script from "./vertify.vue?vue&type=script&lang=js"
export * from "./vertify.vue?vue&type=script&lang=js"
import style0 from "./vertify.vue?vue&type=style&index=0&id=ed9f4fce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9f4fce",
  null
  
)

export default component.exports